import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as FacebookIcon } from "../../assets/Icons/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../assets/Icons/twitter.svg";
import { ReactComponent as Closeicon } from "../../assets/Icons/closeFilled.svg";
import { ReactComponent as PlayIcon } from "../../assets/Icons/play.svg";
import Util from "./util";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useWindowWidth } from "@react-hook/window-size";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../Components/Loading/Loading";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import ShowCard from "../../Components/ShowCard/ShowCard";
import Translate from "../../Components/Multilanguage/Translate";
import { updateUserRating } from "../../network/service";
import { likeHandlerShorts } from "../../utils/utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "./scss/_yowDetailsScreen.scss";

let videoStarted = false;

const MOCK_SIMILAR_VIDEOS = [
  {
    show_id: 101,
    title: "The Counterculture Icon",
    poster_image: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=500&auto=format&fit=crop&q=60",
    genre: "Documentary",
    year: "2024",
    vanity_url: "counterculture-icon"
  },
  {
    show_id: 102,
    title: "Bees & Freedom",
    poster_image: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?w=500&auto=format&fit=crop&q=60",
    genre: "Biography",
    year: "2023",
    vanity_url: "bees-freedom"
  },
  {
    show_id: 103,
    title: "Wild & Unfiltered",
    poster_image: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=500&auto=format&fit=crop&q=60",
    genre: "Indie",
    year: "2025",
    vanity_url: "wild-unfiltered"
  },
  {
    show_id: 104,
    title: "The Off-Grid Legend",
    poster_image: "https://images.unsplash.com/photo-1518676590629-3dcbd9c7a5c1?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1518676590629-3dcbd9c7a5c1?w=500&auto=format&fit=crop&q=60",
    genre: "Drama",
    year: "2024",
    vanity_url: "off-grid-legend"
  },
  {
    show_id: 105,
    title: "Natural Born Rebel",
    poster_image: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=500&auto=format&fit=crop&q=60",
    genre: "Comedy",
    year: "2023",
    vanity_url: "natural-born-rebel"
  },
  {
    show_id: 106,
    title: "Maine Wilderness",
    poster_image: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?w=500&auto=format&fit=crop&q=60",
    genre: "Adventure",
    year: "2025",
    vanity_url: "maine-wilderness"
  },
  {
    show_id: 107,
    title: "Living Free",
    poster_image: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=500&auto=format&fit=crop&q=60",
    genre: "Documentary",
    year: "2024",
    vanity_url: "living-free"
  },
  {
    show_id: 108,
    title: "Behind The Beard",
    poster_image: "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?w=500&auto=format&fit=crop&q=60",
    thumbnail: "https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?w=500&auto=format&fit=crop&q=60",
    genre: "Biography",
    year: "2025",
    vanity_url: "behind-the-beard"
  }
];

const YowDetailsScreen = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userSubscriptionData = useSelector(
    (state) => state?.userSubscription?.value
  );
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const [videoPlay, setVideoPlay] = useState(false);
  const [watchDuration, setWatchDuration] = useState("");
  const [showDetails, setShowDetails] = useState({});
  const [similarVideos, setSimilarVideos] = useState([]);
  const [playerToken, setPlayerToken] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [videoPlayer, setVideoPlayer] = useState("");
  const [watchlistStatus, setWatchlistStatus] = useState("removed");
  const [selectedVideoDetails, setSelectedVideoDetails] = useState();
  const [categories, setCategories] = useState("");
  const [loading, setLoading] = useState(true);
  const [subscribedUser, setSubscribeduser] = useState(false);
  const [subscribeButton, setSubscribeButton] = useState();
  const [isFreeVideo, setIsFreeVideo] = useState(false);
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [isTrailer, setIsTrailer] = useState(false);
  const [isFullReviewOpen, setIsFullReviewOpen] = useState(false);
  const [userRatedCount, setUserRatedValue] = useState();
  const [isEditingRating, setIsEditingRating] = useState(false);
  const [draftRating, setDraftRating] = useState(null);
  const [refetchTrigger, setRefetchTrigger] = useState(null);

  // Custom Interactive YOWTV States
  const [isMuted, setIsMuted] = useState(true);
  const [likesCount, setLikesCount] = useState(0);
  const [hasLiked, setHasLiked] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [commentsList, setCommentsList] = useState([]);

  const location = useLocation();
  const [showId, setShowId] = useState();
  const type = location?.state?.type;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const windowSize = useWindowWidth();

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const playerRef = useRef(null);

  const {
    fetchShowDetails,
    fetchShowDetailsByVanityUrl,
    fetchSimilarVideos,
    fetchPlayerToken,
    addToWatchlist,
    removeFromWatchlist,
    subscriptionCheck,
    handleSubscribe,
    watchVideoHandler,
    handleWatchNowClick,
    updateVideoAnalytics,
    fetchUserSubscriptionDetails,
  } = Util();

  useEffect(() => {
    fetchUserSubscriptionDetails(appInfo, dispatch);
  }, []);

  useEffect(() => {
    if (
      location?.state?.thumbnailOrientation === "PORTRAIT" ||
      (!location?.state?.thumbnailOrientation &&
        projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT")
    ) {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    if (showDetails && Object.keys(showDetails).length > 0) {
      setLoading(false);
      if (showDetails?.user_rated === true) {
        setUserRatedValue(showDetails?.user_rating);
        setDraftRating(Number(showDetails?.user_rating));
      } else {
        setUserRatedValue(null);
        setDraftRating(null);
      }
      if (showDetails?.categories) {
        let categoryNames = showDetails?.categories
          ?.map((item) => item?.category_name)
          .join(", ");
        setCategories(categoryNames);
      }
      const detailLikesCount = Number(showDetails?.like_count);
      setLikesCount(Number.isFinite(detailLikesCount) ? detailLikesCount : 0);
      setHasLiked(showDetails?.liked_flag === true);
      setCommentsList(
        Array.isArray(showDetails?.comments)
          ? showDetails.comments.map((comment, index) => ({
            id: comment?.id || comment?.comment_id || index,
            name: comment?.user?.user_name?.trim() || comment?.name || comment?.user_name || comment?.username || "Viewer",
            image: comment?.user?.user_image || comment?.image_url || null,
            time: comment?.time || comment?.created_at || "",
            text: comment?.content || comment?.text || comment?.comment || comment?.comment_text || "",
            likes: Number(comment?.likes_count ?? comment?.likes ?? comment?.like_count ?? 0),
            liked: comment?.user_has_liked === true || comment?.liked === true || comment?.liked_flag === true,
          }))
          : []
      );
      if (showDetails?.watchlist_flag === 1) {
        setWatchlistStatus("added");
      } else {
        setWatchlistStatus("removed");
      }
      if (showDetails?.single_video === 1 && showDetails?.videos?.length > 0) {
        setSelectedVideoDetails(showDetails?.videos[0]);
      } else if (showDetails?.videos && showDetails?.videos[0]?.videos) {
        setSelectedVideoDetails(showDetails?.videos[0]?.videos[0]);
      } else if (showDetails?.videos && showDetails?.videos[0]) {
        setSelectedVideoDetails(showDetails?.videos[0]);
      }
    }
  }, [showDetails, type]);

  useEffect(() => {
    window.scroll(0, 0);
    const safetyTimer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    if (location?.pathname) {
      let vanityUrl = location?.pathname.split("/")[2];
      let stateShowId = location?.state?.showId;
      if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
        fetchShowDetailsByVanityUrl(
          vanityUrl,
          appInfo,
          setLoading,
          setShowDetails,
          setShowId,
          setSimilarVideos,
          stateShowId || showId
        );
      } else {
        fetchShowDetails(setLoading, setShowDetails, appInfo, stateShowId || showId);
      }
      if (stateShowId || showId) {
        fetchSimilarVideos(null, appInfo, setSimilarVideos, stateShowId || showId);
      }
    }
    return () => clearTimeout(safetyTimer);
  }, [accessToken, projectInfo, location?.pathname]);

  useEffect(() => {
    if (refetchTrigger && location?.pathname) {
      let vanityUrl = location?.pathname.split("/")[2];
      if (vanityUrl !== "null" && vanityUrl !== "undefined" && vanityUrl) {
        fetchShowDetailsByVanityUrl(
          vanityUrl,
          appInfo,
          () => { },
          setShowDetails,
          setShowId,
          setSimilarVideos,
          showId
        );
      } else {
        fetchShowDetails(() => { }, setShowDetails, appInfo, showId);
      }
    }
  }, [refetchTrigger]);

  useEffect(() => {
    if (selectedVideoDetails && Object.keys(selectedVideoDetails).length > 0) {
      if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "true") {
        if (projectInfo?.projectConfig?.config?.SUBSCRIPTION_REQUIRED === "true") {
          let isSubscribedUser = false;
          if (showDetails?.subscriptions?.length > 0) {
            isSubscribedUser = userSubscriptionData?.data?.length > 0
              ? subscriptionCheck(userSubscriptionData?.data, showDetails?.subscriptions)
              : false;
          } else {
            isSubscribedUser = userSubscriptionData?.data?.length > 0
              ? subscriptionCheck(userSubscriptionData?.data, selectedVideoDetails?.subscriptions)
              : false;
          }
          if (isSubscribedUser === true) {
            setSubscribeduser(true);
            setSubscribeButton(false);
          } else {
            setSubscribeduser(false);
            if (selectedVideoDetails?.free_video === true) {
              setSubscribeButton(false);
              setIsFreeVideo(true);
            } else {
              setSubscribeButton(true);
              setIsFreeVideo(false);
            }
          }
        } else {
          setSubscribeduser(true);
          setSubscribeButton(false);
        }
      } else {
        setSubscribeButton(false);
        setSubscribeduser(true);
      }
    }
  }, [selectedVideoDetails, userSubscriptionData]);

  useEffect(() => {
    setVideoPlayer(null);
    if (videoUrl) {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{ src: `${videoUrl}`, type: "application/x-mpegURL" }],
      };
      setLoading(false);
      setVideoPlayer(
        <VideoJS
          autoplay={true}
          options={videoJsOptions}
          onReady={handlePlayerReady}
          isTrailer={true}
        />
      );
    }
  }, [videoUrl]);

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    player.on("play", () => {
      let event = videoStarted === true ? "POP09" : "POP02";
      videoStarted = true;
      updateVideoAnalytics(event, player.currentTime(), appInfo, selectedVideoDetails, categories, showDetails);
    });
  };

  const handleWatchlistToggle = () => {
    if (watchlistStatus === "added") {
      removeFromWatchlist(setWatchlistStatus, appInfo, showId, user);
    } else {
      addToWatchlist(setWatchlistStatus, appInfo, showId, user);
    }
  };

  const handleLikeToggle = async () => {
    const nextLikedState = !hasLiked;
    const videoId = selectedVideoDetails?.video_id || showDetails?.post_id;

    if (!videoId) return;

    const response = await likeHandlerShorts(
      "like/video",
      { id: videoId, liked: nextLikedState },
      appInfo
    );

    const responseStatus = response?.status;
    const likeSucceeded = response != null &&
      response?.success !== false &&
      (responseStatus === undefined || (responseStatus >= 200 && responseStatus < 300));

    if (likeSucceeded) {
      setLikesCount((prev) => nextLikedState ? prev + 1 : Math.max(0, prev - 1));
      setHasLiked(nextLikedState);
    }
  };

  const handleRatingSave = async () => {
    if (!draftRating) return;

    const response = await updateUserRating(appInfo, {
      showId: showDetails?.show_id,
      ratedCount: draftRating,
      review: "",
    });

    if (response?.status === 200) {
      setUserRatedValue(draftRating);
      setIsEditingRating(false);
    }
  };

  const handleInitialRating = async (rating) => {
    const response = await updateUserRating(appInfo, {
      showId: showDetails?.show_id,
      ratedCount: rating,
      review: "",
    });

    if (response?.status === 200) {
      setUserRatedValue(rating);
      setDraftRating(rating);
    }
  };

  const handleRatingCancel = () => {
    setDraftRating(userRatedCount ?? null);
    setIsEditingRating(false);
  };

  const handleAddComment = () => {
    if (!newComment.trim()) return;
    const item = {
      id: Date.now(),
      name: user?.first_name || user?.name || "Viewer",
      time: "Just now",
      text: newComment.trim(),
      likes: 0,
      liked: false,
    };
    setCommentsList([item, ...commentsList]);
    setNewComment("");
  };

  const handleLikeComment = (index) => {
    const updated = [...commentsList];
    if (updated[index].liked) {
      updated[index].likes -= 1;
      updated[index].liked = false;
    } else {
      updated[index].likes += 1;
      updated[index].liked = true;
    }
    setCommentsList(updated);
  };

  const heroImageSrc =
    showDetails?.hero_image ||
    showDetails?.logo_thumb ||
    `${process.env.PUBLIC_URL}/assets/Images/hero_placeholder.jpg`;
  const heroImageUrl = /^https?:\/\//i.test(heroImageSrc)
    ? heroImageSrc
    : `${process.env.REACT_APP_IMAGE_URL}${heroImageSrc}`;
  const titleImageSrc = showDetails?.image_title;
  const titleImageUrl = titleImageSrc
    ? (/^https?:\/\//i.test(titleImageSrc)
      ? titleImageSrc
      : `${process.env.REACT_APP_IMAGE_URL}${titleImageSrc}`)
    : null;
  const numericDetailValue = (...values) => {
    const value = values.find((candidate) => candidate !== null && candidate !== undefined && candidate !== "" && !Number.isNaN(Number(candidate)));
    return value === undefined ? null : Number(value);
  };
  const reviewData = showDetails?.review_data || {};
  // const reviewData = {};
  const castNames = (showDetails?.cast || [])
    .map((castMember) => castMember?.name)
    .filter(Boolean)
    .join(", ");
  const reviewScore = numericDetailValue(reviewData?.rating);
  const hasReview = Boolean(reviewData?.short_review || reviewData?.full_review || reviewScore !== null);
  const fanScore = Math.min(
    10,
    Math.max(
      0,
      numericDetailValue(showDetails?.show_rating) ?? 0
    )
  );
  const userRating = numericDetailValue(userRatedCount, showDetails?.user_rating);
  const fanRatingsCount = numericDetailValue(showDetails?.number_of_rating) ?? 0;
  const hasFanRatings = fanRatingsCount > 0;
  const fanScoreDashOffset = 314 - (fanScore / 10) * 314;
  const formattedLikesCount = new Intl.NumberFormat("en", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(likesCount);
  const similarItems = similarVideos?.length > 0 ? similarVideos : MOCK_SIMILAR_VIDEOS;
  const similarSwiperRef = useRef(null);
  const [isSimilarBeginning, setIsSimilarBeginning] = useState(true);
  const [isSimilarEnd, setIsSimilarEnd] = useState(false);

  const updateSimilarNavigationState = (swiper) => {
    setIsSimilarBeginning(swiper?.isBeginning ?? true);
    setIsSimilarEnd(swiper?.isEnd ?? false);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={`yowDetailsScreen ${isRTL ? "rtl" : ""}`} role="main">
      {/* ================= HERO BANNER SECTION (1440x720 Aesthetic) ================= */}
      <div className="yow-hero-section">
        <div className="yow-hero-bg-wrapper">
          <img src={heroImageUrl} alt={showDetails?.show_name} className="yow-hero-img" />
          {/* Multi-layered Dark Gradient Overlays matching Figma SVG viewBox="0 0 1440 720" */}
          <div className="yow-hero-radial-1" />
          <div className="yow-hero-radial-2" />
          <div className="yow-hero-linear-dark" />
        </div>

        {/* Video Player Modal/Overlay if active */}
        {isTrailer && (
          <div className="yow-trailer-overlay">
            <div className="yow-trailer-close" onClick={() => setIsTrailer(false)}>
              <Closeicon />
            </div>
            <div className="yow-trailer-player">{videoPlayer}</div>
          </div>
        )}

        {isFullReviewOpen && (
          <div className="yow-full-review-overlay" role="dialog" aria-modal="true" aria-labelledby="yow-full-review-title">
            <div className="yow-full-review-modal">
              <button
                type="button"
                className="yow-full-review-close"
                onClick={() => setIsFullReviewOpen(false)}
                aria-label="Close full review"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
                  <path d="M14.25 14.25L0.75 0.75" stroke="#D1D1D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.25 0.75L0.75 14.25" stroke="#D1D1D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="yow-full-review-header">
                {titleImageUrl && (
                  <img
                    className="yow-full-review-title-image"
                    src={titleImageUrl}
                    alt=""
                  />
                )}
                <div className="yow-full-review-heading-row">
                  <h2 id="yow-full-review-title">{showDetails?.show_name || "Show review"}</h2>
                  {reviewScore !== null && <strong>{reviewScore}<span>/10</span></strong>}
                </div>
                <p>{showDetails?.director ? `Director: ${showDetails.director}` : ""}{showDetails?.year ? ` · ${showDetails.year}` : ""}</p>
              </div>
              <div className="yow-full-review-body">
                {(reviewData?.full_review || "No full review is available for this show yet.")
                  .split(/\n\s*\n/)
                  .map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
              </div>
            </div>
          </div>
        )}

        {/* Hero Details Content */}
        <div className="yow-hero-content-container">
          {/* Show Title */}
          <h1 className="yow-hero-title-text">
            {showDetails?.show_name || "Burt"}
          </h1>

          <div className="yow-hero-description">
            <span className="yow-description-lead">Pause/Rewind:</span>{" "}
            {showDetails?.sub_text ||
              "Filmed in under 10 days for 7K. Florida Film Festival '25"}
            <br />
            {showDetails?.video_description ||
              "Special Grand Jury Winner. The filmmakers embraced a minimalist style centered on dialogue and character relationships."}
          </div>

          {/* Directed by */}
          <div className="yow-directed-by">
            Directed by <span>{showDetails?.director || "Jody Shapiro"}</span>
          </div>

          {/* Action CTAs Row */}
          <div className="yow-hero-cta-row">
            {/* Primary PLAY Button */}
            {!showDetails?.hide_play_button && (
              <button
                className="yow-btn-play"
                onClick={() =>
                  handleWatchNowClick(
                    selectedVideoDetails,
                    showId,
                    setSelectedVideoDetails,
                    showDetails,
                    categories,
                    thumbnailOrientation,
                    appInfo,
                    user,
                    setRefetchTrigger
                  )
                }
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M15 8.00001C15.0004 8.16977 14.9569 8.33676 14.8736 8.48472C14.7904 8.63268 14.6703 8.75659 14.525 8.84438L5.52 14.3531C5.36818 14.4461 5.19429 14.4969 5.0163 14.5001C4.83831 14.5034 4.66266 14.4592 4.5075 14.3719C4.35382 14.286 4.2258 14.1606 4.1366 14.0088C4.04741 13.857 4.00026 13.6842 4 13.5081V2.49188C4.00026 2.31581 4.04741 2.14298 4.1366 1.99118C4.2258 1.83937 4.35382 1.71406 4.5075 1.62813C4.66266 1.54085 4.83831 1.49657 5.0163 1.49987C5.19429 1.50316 5.36818 1.55391 5.52 1.64688L14.525 7.15563C14.6703 7.24343 14.7904 7.36733 14.8736 7.51529C14.9569 7.66326 15.0004 7.83024 15 8.00001Z" fill="#0D0D0C" />
                </svg>
                <span>{showDetails?.button_text || <Translate textKey={"watch_now"} />}</span>
              </button>
            )}

            {/* Glassmorphism Watchlist Button */}
            <button
              className={`yow-btn-watchlist ${watchlistStatus === "added" ? "active" : ""}`}
              onClick={handleWatchlistToggle}
            >
              <span>{watchlistStatus === "added" ? "✓ IN WATCHLIST" : "+ WATCHLIST"}</span>
            </button>

          </div>

        </div>

        <button
          className="yow-btn-mute"
          onClick={() => setIsMuted(!isMuted)}
          title={isMuted ? "Unmute sound" : "Mute sound"}
        >
          {isMuted ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 5L6 9H2v6h4l5 4V5z" />
              <line x1="23" y1="9" x2="17" y2="15" />
              <line x1="17" y1="9" x2="23" y2="15" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" />
            </svg>
          )}
        </button>
      </div>

      <div className="yow-details-meta-row" aria-label="Show metadata">
        {(showDetails?.categories?.length > 0
          ? showDetails.categories.map((category) => category?.category_name)
          : ["Comedy", "Drama"]
        ).map((category, index) => (
          <span key={`${category}-${index}`} className="yow-details-meta-item">
            {category}
          </span>
        ))}
        {showDetails?.rating && <span className="yow-details-meta-item">{showDetails?.rating}</span>}
        {showDetails?.year && <span className="yow-details-meta-item">{showDetails?.year}</span>}
        <button
          type="button"
          className={`yow-details-meta-item yow-details-like-item ${hasLiked ? "liked" : ""}`}
          onClick={handleLikeToggle}
          aria-label="Like this show"
        >
          <span className="yow-details-heart" aria-hidden="true">
            {hasLiked ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M18.75 7.96875C18.75 13.4375 10.6414 17.8641 10.2961 18.0469C10.2051 18.0958 10.1033 18.1215 10 18.1215C9.89665 18.1215 9.79492 18.0958 9.70391 18.0469C9.35859 17.8641 1.25 13.4375 1.25 7.96875C1.25145 6.68455 1.76223 5.45337 2.6703 4.5453C3.57837 3.63723 4.80955 3.12645 6.09375 3.125C7.70703 3.125 9.11953 3.81875 10 4.99141C10.8805 3.81875 12.293 3.125 13.9062 3.125C15.1904 3.12645 16.4216 3.63723 17.3297 4.5453C18.2378 5.45337 18.7486 6.68455 18.75 7.96875Z" fill="#FF640A" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 17.5C10 17.5 1.875 13.125 1.875 7.96875C1.875 6.84987 2.31947 5.77681 3.11064 4.98564C3.90181 4.19447 4.97487 3.75 6.09375 3.75C7.85859 3.75 9.37031 4.71172 10 6.25C10.6297 4.71172 12.1414 3.75 13.9062 3.75C15.0251 3.75 16.0982 4.19447 16.8894 4.98564C17.6805 5.77681 18.125 6.84987 18.125 7.96875C18.125 13.125 10 17.5 10 17.5Z" stroke="#D1D1D0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </span>
          <span>{formattedLikesCount}</span>
        </button>
      </div>

      {/* ================= MIDDLE SECTION (SYNOPSIS & CREATORS) ================= */}
      <div className="yow-middle-container">
        <div className="yow-middle-grid">
          {/* Left Column: Synopsis */}
          <div className="yow-synopsis-column">
            <h2 className="yow-column-heading">Synopsis</h2>
            <div className="yow-synopsis-body">
              <p>
                {showDetails?.synopsis ||
                  showDetails?.video_description ||
                  "An affectionate, engrossing look at Burt Shavitz, the reclusive bee-keeper who became the iconic face of Burt's Bees. The film explores his eccentric life, his complicated relationship with co-founder Roxanne Quimby, and his transition into an unexpected global pop-culture celebrity."}
              </p>
            </div>
          </div>

          {/* Right Column: Creators */}
          <div className="yow-creators-column">
            <div className="yow-creators-header">
              <h2 className="yow-column-heading">Creators</h2>
              <span className="yow-heading-arrow" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 3L11 8L6 13" stroke="#8A8A88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>
            <div className="yow-creators-body">
              <div className="yow-creator-detail-row">
                <span className="yow-creator-label">Directed by</span>
                <span className="yow-creator-value">
                  {showDetails?.director || "Jody Shapiro"}
                </span>
              </div>
              <div className="yow-creator-detail-row">
                <span className="yow-creator-label">Starring</span>
                <span className="yow-creator-value">
                  {castNames || "Not available"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= COMMUNITY ROW (FILM THREAT, FAN SCORE, COMMENTS) ================= */}
      <div className="yow-community-container">
        <div className="yow-community-grid">
          {/* Card 1: Film Threat Review */}
          <div className={`yow-community-card yow-review-card ${!hasReview ? "is-empty" : ""}`}>
            {hasReview ? (
              <>
                <div className="yow-review-score-panel">
                  <span className="yow-rating-score-badge">{reviewScore ?? "-"}</span>
                  <span className="yow-rating-denom">/10</span>
                  {titleImageUrl ? (
                    <img
                      className="yow-title-image"
                      src={titleImageUrl}
                      alt={`${showDetails?.show_name || "Show"} title`}
                    />
                  ) : (
                    <span className="yow-brand-tag">{showDetails?.show_name || "Burt"}</span>
                  )}
                </div>
                <div className="yow-review-copy">
                  <blockquote className="yow-card-quote">
                    {reviewData?.short_review}
                  </blockquote>
                  <div className="yow-review-footer">
                    <span>{reviewData?.reviewed_by || "Review details unavailable"}</span>
                    <button
                      type="button"
                      className="yow-card-action-link"
                      onClick={() => reviewData?.full_review && setIsFullReviewOpen(true)}
                      disabled={!reviewData?.full_review}
                    >
                      {reviewData?.full_review ? "Read full review" : "Review unavailable"} <span aria-hidden="true">›</span>
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="yow-review-empty-state">
                <div className="yow-review-empty-icon-panel">
                  <svg className="yow-review-empty-icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M8 54V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H54C54.5304 12 55.0391 12.2107 55.4142 12.5858C55.7893 12.9609 56 13.4696 56 14V54L48 50L40 54L32 50L24 54L16 50L8 54Z" stroke="#D1D1D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M37 27H46" stroke="#D1D1D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M37 37H46" stroke="#D1D1D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M28 24H18V40H28V24Z" stroke="#D1D1D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="yow-review-empty-desc">
                  <div className="title-wrapper"><span className="title">No critic review yet</span></div>
                  <div><span className="subtitle">Check back soon.</span></div>
                  <div><span className="subtitle">We'll add one when it's published.</span></div>
                </div>
              </div>
            )}
          </div>

          {/* Card 2: Fan Score Ring Gauge */}
          <div className={`yow-community-card yow-fanscore-card ${!hasFanRatings ? "is-empty" : ""}`}>
            <div className="yow-fanscore-main">
              <div className="yow-gauge-wrapper">
                <svg className="yow-gauge-svg" viewBox="0 0 120 120">
                  <circle cx="60" cy="60" r="50" className="yow-gauge-track" />
                  <circle
                    cx="60"
                    cy="60"
                    r="50"
                    className="yow-gauge-fill"
                    style={{ strokeDashoffset: fanScoreDashOffset }}
                  />
                </svg>
                <div className={`yow-gauge-score-box ${!hasFanRatings && !(userRating > 0) ? "is-empty" : ""}`}>
                  {!hasFanRatings && !(userRating > 0) ? (
                    <>
                      <span className="yow-no-ratings-dash">_</span>
                      <span className="yow-no-ratings-label">No ratings</span>
                    </>
                  ) : (
                    <>
                      <span className="yow-score-num">{fanScore.toFixed(1)}</span>
                      <span className="yow-score-denom">/10</span>
                    </>
                  )}
                </div>
              </div>
              <div className="yow-fanscore-details">
                {!hasFanRatings && !(userRating > 0) ? (
                  <div className="yow-first-rating">
                    <span className="yow-fanscore-label">It's the first to rate {showDetails?.show_name || "this show"}</span>
                    <div className="yow-rating-options">
                      {Array.from({ length: 10 }, (_, index) => index + 1).map((rating) => (
                        <button
                          type="button"
                          key={rating}
                          className="yow-rating-option"
                          ref={(element) => element?.style.setProperty("border-radius", "50%", "important")}
                          onClick={() => handleInitialRating(rating)}
                        >
                          {rating}
                        </button>
                      ))}
                    </div>
                  </div>
                ) : isEditingRating ? (
                  <div className="yow-rating-editor">
                    <span className="yow-fanscore-label">Changed your mind on {showDetails?.show_name || "this show"}?</span>
                    <div className="yow-rating-options">
                      {Array.from({ length: 10 }, (_, index) => index + 1).map((rating) => (
                        <button
                          type="button"
                          key={rating}
                          className={`yow-rating-option ${draftRating === rating ? "selected" : ""}`}
                          ref={(element) => element?.style.setProperty("border-radius", "50%", "important")}
                          onClick={() => setDraftRating(rating)}
                        >
                          {rating}
                        </button>
                      ))}
                    </div>
                    <div className="yow-rating-editor-actions">
                      <button type="button" onClick={handleRatingSave} disabled={!draftRating}>Save</button>
                      <button type="button" onClick={handleRatingCancel}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <span className="yow-fanscore-label">Your rating</span>
                    <div className="yow-rating-action-row">
                      <button
                        type="button"
                        className="yow-user-rating-pill"
                        ref={(element) => element?.style.setProperty("border-radius", "50%", "important")}
                        onClick={() => {
                          setDraftRating(userRating);
                          setIsEditingRating(true);
                        }}
                      >
                        <span>{userRating ?? "Rate"}</span>
                      </button>
                      <button type="button" className="yow-change-rating" onClick={() => {
                        setDraftRating(userRating);
                        setIsEditingRating(true);
                      }}>Change</button>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="yow-ratings-total"><span>Fan ratings</span><strong>{fanRatingsCount.toLocaleString()}</strong></div>
          </div>

          {/* Card 3: Comments Section */}
          <div className={`yow-community-card yow-comments-card ${commentsList.length === 0 ? "is-empty" : ""}`}>
            <div className="yow-comments-card-header">
              <h3>Comments{commentsList.length > 0 ? ` ${commentsList.length}` : ""}</h3>
              <span className="yow-heading-arrow" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 3L11 8L6 13" stroke="#8A8A88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>

            {/* Composer Box */}
            <div className="yow-composer-box">
              <div className="yow-user-avatar">
                {user?.first_name ? user.first_name[0] : localStorage.getItem(('user_email')[0])}
              </div>
              <input
                type="text"
                placeholder="Add a comment..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleAddComment()}
                className="yow-comment-input"
              />
              <button className="yow-comment-submit-btn" onClick={handleAddComment}>
                Post
              </button>
            </div>

            {/* Comments List */}
            <div className={`yow-comments-stream ${commentsList.length === 0 ? "is-empty" : ""}`}>
              {commentsList.length === 0 ? (
                <div className="yow-comments-empty-state">
                  <svg className="yow-empty-state-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4.06255 17.25C3.04388 15.3469 2.74312 13.141 3.21513 11.0347C3.68715 8.92834 4.90048 7.0618 6.63389 5.77542C8.36731 4.48904 10.5053 3.86851 12.6581 4.02699C14.8108 4.18546 16.8349 5.11239 18.3613 6.63874C19.8876 8.16509 20.8146 10.1892 20.973 12.3419C21.1315 14.4947 20.511 16.6327 19.2246 18.3661C17.9382 20.0995 16.0717 21.3129 13.9653 21.7849C11.859 22.2569 9.65315 21.9562 7.75005 20.9375L4.28005 21.9575C4.10775 22.0081 3.925 22.0113 3.751 21.9669C3.577 21.9225 3.41816 21.8321 3.29118 21.7051C3.1642 21.5781 3.07375 21.4193 3.02935 21.2453C2.98494 21.0713 2.9882 20.8885 3.0388 20.7162L4.06255 17.25Z" stroke="#D1D1D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M20.4924 10.0138C22.0043 10.096 23.4711 10.5583 24.7568 11.3579C26.0426 12.1576 27.1059 13.2686 27.8482 14.5883C28.5904 15.908 28.9878 17.3937 29.0034 18.9077C29.019 20.4218 28.6524 21.9153 27.9374 23.25L28.9574 26.72C29.008 26.8923 29.0113 27.0751 28.9669 27.2491C28.9225 27.4231 28.8321 27.5819 28.7051 27.7089C28.5781 27.8359 28.4193 27.9263 28.2453 27.9708C28.0713 28.0152 27.8885 28.0119 27.7162 27.9613L24.2499 26.9375C23.1049 27.5499 21.841 27.9074 20.5449 27.9856C19.2488 28.0638 17.9511 27.8608 16.7408 27.3905C15.5304 26.9202 14.4361 26.1938 13.5328 25.261C12.6295 24.3282 11.9386 23.2111 11.5074 21.9863" stroke="#D1D1D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <strong>No comments yet</strong>
                  <span>Be the first to share what you thought.</span>
                </div>
              ) : commentsList.map((item, idx) => (
                <div key={item.id || idx} className="yow-comment-row">
                  <div className="yow-comment-author-avatar">
                    {item.image ? <img src={item.image} alt="" /> : item.name[0]}
                  </div>
                  <div className="yow-comment-content">
                    <div className="yow-comment-meta">
                      <span className="yow-author-name">{item.name}</span>
                      <span className="yow-comment-time">{item.time}</span>
                    </div>
                    <p className="yow-comment-text">{item.text}</p>
                    <div className="yow-comment-footer">
                      <button
                        className={`yow-comment-like-btn ${item.liked ? "liked" : ""}`}
                        onClick={() => handleLikeComment(idx)}
                      >
                        {item.liked ? "♥" : "♡"} {item.likes}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ================= CAROUSEL / YOU MAY ALSO LIKE SECTION ================= */}
      <div className="yow-carousel-container">
        <h2 className="yow-carousel-heading">
          <Translate textKey={"you_may_also_like"} />
        </h2>
        <Swiper
          modules={[Navigation]}
          navigation={false}
          onSwiper={(swiper) => {
            similarSwiperRef.current = swiper;
            updateSimilarNavigationState(swiper);
          }}
          onSlideChange={updateSimilarNavigationState}
          allowTouchMove={true}
          simulateTouch={true}
          touchRatio={1}
          touchAngle={30}
          threshold={5}
          grabCursor={true}
          touchStartPreventDefault={false}
          touchMoveStopPropagation={false}
          spaceBetween={20}
          slidesPerView={5}
          watchSlidesProgress
          className="yow-similar-swiper"
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 10 },
            480: { slidesPerView: 3, spaceBetween: 10 },
            641: { slidesPerView: 4, spaceBetween: 10 },
            768: { slidesPerView: 5, spaceBetween: 10 },
            980: { slidesPerView: 6, spaceBetween: 10 },
            1200: { slidesPerView: 7, spaceBetween: 10 },
          }}
        >
          {similarItems.map((item, index) => (
            <SwiperSlide key={item?.show_id || item?.video_id || index}>
              <ShowCard
                data={item}
                metaData={true}
                type="SIMILAR_VIDEOS"
                thumbnailOrientation="PORTRAIT"
                showId={showId}
                isPriority={index < 5}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="yow-similar-controls">
          <button
            type="button"
            className={`yow-similar-prev ${isSimilarBeginning ? "swiper-button-disabled" : ""}`}
            aria-label="Previous slide"
            disabled={isSimilarBeginning}
            onClick={() => similarSwiperRef.current?.slidePrev()}
          >
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect width="44" height="44" fill="#4D4C4B" />
              <path d="M24.5 15.75L18.25 22L24.5 28.25" stroke="#F6F6F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <button
            type="button"
            className={`yow-similar-next ${isSimilarEnd ? "swiper-button-disabled" : ""}`}
            aria-label="Next slide"
            disabled={isSimilarEnd}
            onClick={() => similarSwiperRef.current?.slideNext()}
          >
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect width="44" height="44" fill="#4D4C4B" />
              <path d="M19.5 15.75L25.75 22L19.5 28.25" stroke="#F6F6F6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default YowDetailsScreen;
